let geStartedButton = document.querySelector(".banner__buttons > a");
geStartedButton
  ? (geStartedButton.href =
      "#shopify-section-template--15442729828436__tailored_packs_pJWdfq")
  : null;
let terms = document.querySelector("#terms #check");
let checkoutButtonTooltip = document.getElementById("tooltip");
let checkoutButton = document.getElementById("no-tooltip");
let remo;
if (terms?.checked) {
  checkoutButton.style.display = "block";
  checkoutButtonTooltip.style.display = "none";
} else if (checkoutButton) {
  checkoutButton.style.display = "none";
  checkoutButtonTooltip.style.display = "block";
}
var triggerCardsATC = function (e, el) {
  e.preventDefault();
  e.stopPropagation();
  let atcBtn = el.closest(".card").querySelector(".quick-add__submit");
  if (atcBtn) {
    atcBtn.click();
  }
};
const url = window.location.href;
if (url.includes("productsBundler")){
console.log("type", url);
personalizePack()
}

var selectedBundles = [];

var toggleselectThisForCart = function (varId) {
  if (selectedBundles.length && selectedBundles.includes(varId)) {
    selectedBundles.splice(selectedBundles.indexOf(varId), 1);
  } else {
    selectedBundles.push(varId);
  }
};

var addSelectedProductsToCart = function () {
  let itemsObj = [];
  selectedBundles.forEach(function (prod) {
    itemsObj.push({
      id: +prod,
      quantity: 1,
    });
  });
  if (itemsObj.length) {
    let formData = {
      items: itemsObj,
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        self.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

function removeCategoriesActiveButThis(trg) {
  let allCategories = document.querySelectorAll(".category_slide");
  if (allCategories.length) {
    allCategories.forEach(function (cat) {
      if (cat != trg) {
        cat.classList.remove("active");
      }
    });
  }
}

function filterPackProductsByHandles(trg) {
  let prodAttribute = trg.getAttribute("data-products");
  let productsHandles = prodAttribute.split(",");
  let allProducts = document.querySelectorAll(".product__pack_card");
  if (productsHandles.length && allProducts.length) {
    allProducts.forEach(function (prodEl) {
      let handleProd = prodEl.getAttribute("data-handle");
      let parentCell = prodEl.parentElement;
      let isProd = false;
      if (parentCell) {
        parentCell.style.display = "none";
        productsHandles.forEach(function (handle) {
          if (handle == handleProd) {
            isProd = true;
          }
          if (handle == "all") {
            isProd = true;
          }
        });
        if (isProd == true) {
          parentCell.style.display = "block";
        }
      }
    });
  }
  trg.classList.add("active");
  removeCategoriesActiveButThis(trg);
}

function addAvailablePackProductsToCart(packATCButton, route) {
  let addToCartButton = document.getElementsByClassName("pack__addtocart")[0];
  let oldText = addToCartButton.innerHTML
  addToCartButton.innerHTML = "";
  let sHtm = `
    <div class="loading__spinner">
    <svg
      aria-hidden="true"
      focusable="false"
      class="spinner"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle class="path circle-white" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
  </div>
  `;
  addToCartButton.insertAdjacentHTML("afterbegin", sHtm);
  let allProducts = document.querySelectorAll(".product__pack_card");
  let bundleProd = packATCButton.getAttribute("data-pack");
  let itemsObj = [];
  if (allProducts.length) {
    allProducts.forEach(function (prod) {
      let selectedQty = prod.getAttribute("data-selectedquantity");
      let varId = prod.getAttribute("data-variant");
      itemsObj.push({
        id: +varId,
        quantity: +selectedQty,
        properties: {
          _packproduct: JSON.parse(bundleProd),
        },
      });
    });
  }
  if (itemsObj.length && !document.body.classList.contains("addingPacks")) {
    document.body.classList.add("addingPacks");
    let formData = {
      items: itemsObj,
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        // addInstallation();
        return response.json();
      })
      .then((data) => {
        document.body.classList.remove("addingPacks");
        route.includes("checkout")
          ? (self.location.href = route)
          : openAddToCartModal(route);
        addToCartButton.innerHTML = oldText;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

function openAddToCartModal(route){
  var modalConfirm = document.getElementById("myModalConfirm");
  var body = document.getElementsByTagName("body")[0];
  var confirmButton = document.getElementById("confirm");
  modalConfirm.style.display = "block";
  body.style.overflow = "hidden";
  confirmButton.onclick = () => {
    self.location.href = route
  }
}

function addInstallation() {
  let varId = 41699327213652;
  let itemsObj = [
    {
      id: varId,
      quantity: 1,
    },
  ];
  let formData = {
    items: itemsObj,
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

document.addEventListener("click", function (e) {
  let trg = e.target;
  let packATCButton = trg.closest(".pack__addtocart")
    ? trg.closest(".pack__addtocart")
    : trg.classList.contains("pack__addtocart")
    ? trg
    : null;
  let editButton = trg.closest(".edit")
    ? trg.closest(".edit")
    : trg.classList.contains("edit-button")
    ? trg
    : null;
  let packBuyButton = trg.closest(".pack_button_buynow")
    ? trg.closest(".pack_button_buynow")
    : trg.classList.contains("pack_button_buynow")
    ? trg
    : null;
  let packRowBtnCart = trg.closest(".packprodrow")
    ? trg.closest(".packprodrow")
    : null;
  let packRemoveBtn = trg.closest(".removePackProduct")
    ? trg.closest(".removePackProduct")
    : trg.classList.contains("removePackProduct")
    ? trg
    : null;
  let delete_loader = document.querySelectorAll(
    `.loading__spinner.${
      trg.classList.length == 1
        ? trg.classList[0]
        : trg.classList.length == 3
        ? trg.classList[2]
        : trg.classList[1]
    }`
  )[0];
  let delete_loader_mobile = document.querySelectorAll(
    `.loading__spinner.mobile-loader.${
      trg.classList.length == 1
        ? trg.classList[0]
        : trg.classList.length == 3
        ? trg.classList[2]
        : trg.classList[1]
    }`
  )[0];
  let delete_mobile = document.querySelectorAll(
    `.removePackProduct.mobile-remove.${
      trg.classList.length == 1
        ? trg.classList[0]
        : trg.classList.length == 3
        ? trg.classList[2]
        : trg.classList[1]
    }`
  )[0];
  if (editButton) {
    editPacakageFromCart(e)
  }
  if (trg.classList.contains("category_slide")) {
    filterPackProductsByHandles(trg);
  }
  if (packATCButton) {
    addAvailablePackProductsToCart(packATCButton, "/cart");
  }
  if (packBuyButton) {
    addAvailablePackProductsToCart(packBuyButton, "/checkout");
  }
  if (packRowBtnCart) {
    let parent = packRowBtnCart.parentElement;
    if (parent) {
      // parent.classList.toggle("showall");
    }
  }
  if (packRemoveBtn) {
    console.log("here", packRemoveBtn);
    e.stopPropagation();
    if (delete_mobile) {
      delete_mobile.style.display = "none";
      delete_loader_mobile.style.display = "block";
    }
    delete_loader.style.display = "block";
    let childProducts = packRemoveBtn
      .closest(".cart__packproduct")
      .querySelectorAll(".child_prod");
    console.log("childProducts", childProducts);
    let varIdsToRemove = [];
    if (childProducts.length) {
      childProducts.forEach(function (prod) {
        let lineKey = prod.getAttribute("data-linekey");
        if (lineKey) {
          varIdsToRemove.push(lineKey);
        }
      });
    }
    if (varIdsToRemove.length && !document.querySelector(".removingProducts")) {
      document.body.classList.add("removingProducts");
      removePackProductsFromCart(varIdsToRemove);
    }
  }
});

function removePackProductsFromCart(variantIdsArray, redirectUrl=null) {
  let finalJSON = {
    updates: {},
  };
  variantIdsArray.forEach(function (varId) {
    finalJSON.updates[varId] = 0;
  });
  if (finalJSON) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(finalJSON),
    })
      .then((data) => data.json())
      .then((res) => {
        if (redirectUrl) {
          window.location = "https://www.movin.ae/products/" + redirectUrl + "#productsBundler";
        } else location.reload();
      });
  }
}

const formatter_currency = new Intl.NumberFormat("en-AE", {
  // style: "currency",
  // currency: "AED",
  minimumFractionDigits: 2,
});

if (location.href.includes("/cart")) {
  checkBundledProductsInCart();
  combineAllProductsToAPackBody();

  let targetNode = document.querySelector("#MainContent");
  let config = { attributes: false, childList: true, subtree: true };
  let observer = new MutationObserver(function () {
    checkBundledProductsInCart();
    combineAllProductsToAPackBody();
  });
  observer.observe(targetNode, config);
}

function checkBundledProductsInCart() {
  let allProds = document.querySelectorAll("tr.cart-item[data-properties]");
  let packProductHandle = "";
  if (allProds.length) {
    let packProduct = null;
    allProds.forEach(function (prod) {
      let props = JSON.parse(prod.dataset.properties) || [];
      if (props.length && props[0][0] == "_packproduct") {
        if (packProductHandle != props[0][1].handle) {
          packProduct = props[0][1];
          addPackageBannerInCart(allProds, packProduct);
          packProductHandle = props[0][1].handle;
        }
      }
    });
  }
}

function addPackageBannerInCart(allProds, packProduct) {
  if (packProduct != null) {
    let products = document.getElementsByClassName(
      `${packProduct.title}-package`
    );
    let newPack = packages[packProduct.handle].reverse().map(el => `<div><img src="${el.image}" width="50" height="50"/> <div>${el.product} <span>Quantity: ${el.quantity}</span></div></div>`)

    let sHtm = `
      <tr class="packprodrow cart-item cart__packproduct" data-pack="${
        packProduct.handle
      }">
        <td class="cart-item__image-container gradient global-media-settings">
          <img class="cart-item__image" src="${packProduct.featured_image}" />
        </td>
        <td class="cart-item__details">
          <h3>${packProduct.title}</h3>
          <div style="display: flex; align-items: self-start;">
            <div id="${packProduct.handle}-button-show" style="cursor: pointer; text-decoration: underline" onclick="toggleView('${packProduct.handle}')">View Products</div>
            <div id="${packProduct.handle}-button-hide" style="cursor: pointer; text-decoration: underline; display: none" onclick="toggleView('${packProduct.handle}')">Hide Products</div>
            <div class="edit edit-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
                  <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"/>
                </svg>
            </div>
          </div>
          <div id="${packProduct.handle}-products-list" class="accordian-list" style="display: none">${newPack.join('')}</div>
          </td>
        <td class="pack-product-price" id="${packProduct.handle}">
          
        </td>
        <td class="package-quantity" style="padding-left: 5rem !important;">
          <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
            <quantity-input class="quantity cart-quantity" style="width: 121px">
              <input class="quantity__input" data-quantity-variant-id="41642643456084" type="number" name="updates[]" value="1" data-cart-quantity="1" min="0" data-min="1" step="1" aria-label="Quantity for COFFEE TABLE" id="Quantity-83" data-index="83">
            </quantity-input>
            <button class="removePackProduct ${
              packProduct.handle
            }" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove ${
                packProduct.handle
              }">
                <path class="${
                  packProduct.handle
                }" d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path class="${
                  packProduct.handle
                }" d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </button>
          </div>
          <div class="loading__spinner ${
            packProduct.handle
          }" id="delete" style="top: 76px !important; right: -24px !important;">
            <svg
              aria-hidden="true"
              focusable="false"
              class="spinner"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle class="path circle" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </td>
        <td class="package-total-price" style="padding-right: 5px !important; text-align: right;" id="total-price-${
          packProduct.handle
        }">
          AED ${formatter_currency.format(packProduct.price / 100)}
        </td>
      </tr>`;

    let mHtm = `
      <tr class="packprodrow-mobile cart-item cart__packproduct" data-pack="${
        packProduct.handle
      }">
        <td class="cart-item__image-container gradient global-media-settings">
          <img class="cart-item__image" src="${packProduct.featured_image}" />
        </td>
        <td class="cart-item__details">
          <h3>${packProduct.title}</h3>
          <div style="display: flex">
            <div id="${packProduct.handle}-button-show-mobile" style="cursor: pointer; text-decoration: underline;" onclick="toggleViewMobile('${packProduct.handle}')">View Products</div>
            <div id="${packProduct.handle}-button-hide-mobile" style="cursor: pointer; text-decoration: underline; display: none" onclick="toggleViewMobile('${packProduct.handle}')">Hide Products</div>
            <div class="edit edit-button-mobile">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
                <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"/>
              </svg>
            </div>
          </div>
          <div id="${packProduct.handle}-products-list-mobile" class="accordian-list" style="display: none">${newPack.join('')}</div>
        
        <div class="package-quantity">
          <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
            <quantity-input class="quantity cart-quantity" style="width: 96px">
              <input class="quantity__input" data-quantity-variant-id="41642643456084" type="number" name="updates[]" value="1" data-cart-quantity="1" min="0" data-min="1" step="1" aria-label="Quantity for COFFEE TABLE" id="Quantity-83" data-index="83">
            </quantity-input>
            <button class="removePackProduct mobile-remove ${
              packProduct.handle
            }" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove ${
                packProduct.handle
              }">
                <path class="${
                  packProduct.handle
                }" d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path class="${
                  packProduct.handle
                }" d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </button>
          </div>
          <div class="loading__spinner mobile-loader ${
            packProduct.handle
          }" id="delete" style="top: 12px !important; right: 6px !important;">
            <svg
              aria-hidden="true"
              focusable="false"
              class="spinner"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle class="path circle" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </div>
        <td class="package-total-price" style="padding-right: 5px !important; text-align: right;" id="mobile-total-price-${
          packProduct.handle
        }">
          AED<br>${formatter_currency.format(packProduct.price / 100)}
        </td>
      </tr>`;
    
    if (window.innerWidth < 768) {
      products[0].insertAdjacentHTML("beforebegin", mHtm);
    } else {
      products[0].insertAdjacentHTML("beforebegin", sHtm);
    }
  }
}

function combineAllProductsToAPackBody() {
  let allPackProductsBody = document.querySelectorAll(
    ".cart__packproduct[data-pack]"
  );
  let allProdsRow = document.querySelectorAll(
    "tbody:not(.cart__packproduct) > tr[data-properties]"
  );
  let orderSummHead = document.querySelector(".cart__blocks > h3");
  let checkBox = document.getElementById("check-box");
  let _pack;
  let packHandle = [];
  if (allPackProductsBody.length && allProdsRow.length) {
    allPackProductsBody.forEach(function (prod) {
      let pack_handle = prod.getAttribute("data-pack");
      allProdsRow.forEach(function (prodRow) {
        let prop = JSON.parse(prodRow.getAttribute("data-properties"));
        let packSummary = document.querySelectorAll(".pack_summary_prod");
        orderSummHead =
          packSummary.length > 0
            ? packSummary[packSummary.length - 1]
            : orderSummHead;
        if (prop && prop.length) {
          let prodHandle = prop[0][1].handle;
          if (
            pack_handle == prodHandle &&
            !prodRow.classList.contains(".child_prod")
          ) {
            prodRow.classList.add("child_prod");
            prodRow.classList.add(prodHandle);
            prod.insertAdjacentElement("beforeend", prodRow);
          }
          if (orderSummHead) {
            let packProduct =
              _pack?.handle != prop[0][1].handle ? prop[0][1] : null;
            _pack = prop[0][1];
            let prod = document.getElementsByClassName(
              `pack_summary_prod ${prop[0][1].handle}`
            );
            if (packProduct && prod.length == 0) {
              let sHtm = `<div class="pack_summary_prod ${prop[0][1].handle}">
              <h3 style="width: 60%;">${packProduct.title}</h3>
              <div class="prodSummPrice packProduct-${
                packProduct.handle
              }">AED ${formatter_currency.format(packProduct.price / 100)}</div>
            </div>`;
              orderSummHead.insertAdjacentHTML("afterend", sHtm);
            }
          }
          if (!packHandle.includes(prodHandle)) {
            packHandle.push(prodHandle);
          }
        } else {
          let name = document.querySelector(
            `#${prodRow.id} .cart-item__name`
          ).innerHTML;
          let price = document
            .querySelector(`#${prodRow.id} .price.price--end`)
            .innerHTML.trim()
            .split(" ")[1]
            .replace(",", "");
          let id = name.replace("&amp;", "&");
          if (orderSummHead && !document.getElementById(id.toLowerCase())) {
            let sHtm = `<div class="pack_summary_prod">
                <h3 style="width: 60%;" id='${id.toLowerCase()}'>${name}</h3>
                <div class="prodSummPrice">AED ${formatter_currency.format(
                  price
                )}</div>
              </div>`;
            orderSummHead.insertAdjacentHTML("afterend", sHtm);
          }
          let installation = document.getElementById("installation");
          if (installation) {
            checkBox.checked = true;
          }
        }
      });
    });
    getpackageFinalPrice(packHandle);
  } else {
    allProdsRow.forEach(function (prodRow) {
      let name = document.querySelector(
        `#${prodRow.id} .cart-item__name`
      ).innerHTML;
      let price = document
        .querySelector(`#${prodRow.id} .price.price--end`)
        .innerHTML.trim()
        .split(" ")[1]
        .replace(",", "");
      if (orderSummHead) {
        let sHtm = `<div class="pack_summary_prod">
            <h3 style="width: 60%;" id='${name.toLowerCase()}'>${name}</h3>
            <div class="prodSummPrice">AED ${formatter_currency.format(
              price
            )}</div>
          </div>`;
        orderSummHead.insertAdjacentHTML("afterend", sHtm);
      }
    });
    let installation = document.getElementById("installation");
    if (installation) {
      checkBox.checked = true;
    }
  }
}

function getpackageFinalPrice(packageHandle) {
  packageHandle.forEach((el) => {
    let child_prod = document.querySelectorAll(
      `.child_prod.${el} .cart-item__totals.right.small-hide .cart-item__price-wrapper .price.price--end`
    );
    let price = 0;
    for (let el of child_prod) {
      price =
        price + parseFloat(el.innerHTML.trim().split(" ")[1].replace(",", ""));
    }
    let pack = document.querySelector(`#${el}.pack-product-price`);
    let packTotal = document.querySelector(
      `#total-price-${el}.package-total-price`
    );
    let packTotalMobile = document.querySelector(
      `#mobile-total-price-${el}.package-total-price`
    );
    let packProd = document.getElementsByClassName(
      `prodSummPrice packProduct-${el}`
    )[0];
    if (packTotal && packTotal.innerText != formatter_currency.format(price)) {
      packTotal.innerHTML = `AED ${formatter_currency.format(price)}`;
    }
    if (
      packTotalMobile &&
      packTotalMobile.innerHTML != `AED<br>${formatter_currency.format(price)}`
    ) {
      packTotalMobile.innerHTML = `AED<br/>${formatter_currency.format(price)}`;
    }
    pack ? (pack.innerHTML = `AED ${formatter_currency.format(price)}`) : null;
    packProd
      ? (packProd.innerHTML = `AED ${formatter_currency.format(price)}`)
      : null;
  });
}

function personalizePack() {
  let selectors = document.getElementsByClassName("quantity-selectors");
  for (let selector of selectors) {
    selector.style.display = "inline-flex";
    selector.style.justifyContent = "space-around";
  }
}

function toggleInstallation() {
  let varId = 41699327213652;
  let itemsObj = [
    {
      id: varId,
      quantity: 1,
    },
  ];
  let formData = {
    items: itemsObj,
  };
  let finalJSON = {
    updates: {},
  };
  let checkBox = document.getElementById("check-box");
  if (checkBox.checked) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    finalJSON.updates[varId] = 0;
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(finalJSON),
    })
      .then((data) => data.json())
      .then((res) => {
        location.reload();
      });
  }
}

function removeItemFromCart(itemId) {
  let finalJSON = {
    updates: {},
  };
  finalJSON.updates[itemId] = 0;
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(finalJSON),
  })
    .then((data) => data.json())
    .then((res) => {
      location.reload();
    });
}

function toggleCheckout() {
  let terms = document.querySelector("#terms #check");
  let checkoutButtonTooltip = document.getElementById("tooltip");
  let checkoutButton = document.getElementById("no-tooltip");
  let noteTextArea = document.getElementById("cart-note");
  let deliveryDate = document.getElementById("delivery-date");
  noteTextArea.value = "Delivery Date(YYYY-MM-DD): " + deliveryDate.value;
  if (terms.checked && deliveryDate.value) {
    checkoutButton.style.display = "block";
    checkoutButtonTooltip.style.display = "none";
  } else {
    checkoutButton.style.display = "none";
    checkoutButtonTooltip.style.display = "block";
  }
}

function toggleView(packageHandle) {
  let list = document.getElementById(`${packageHandle}-products-list`)
  let showButton = document.getElementById(`${packageHandle}-button-show`)
  let hideButton = document.getElementById(`${packageHandle}-button-hide`)
  if (list.style.display != "none"){
    list.style.display = "none";
    showButton.style.display = "block";
    hideButton.style.display = "none";
  }
  else {
    list.style.display = "block";
    hideButton.style.display = "block";
    showButton.style.display = "none";
  }
}

function toggleViewMobile(packageHandle) {
  let list = document.getElementById(`${packageHandle}-products-list-mobile`)
  let showButton = document.getElementById(`${packageHandle}-button-show-mobile`)
  let hideButton = document.getElementById(`${packageHandle}-button-hide-mobile`)
  if (list.style.display != "none"){
    list.style.display = "none";
    showButton.style.display = "block";
    hideButton.style.display = "none";
  }
  else {
    list.style.display = "block";
    hideButton.style.display = "block";
    showButton.style.display = "none";
  }
}



let editButtons = document.querySelectorAll(".edit")
// const editButtonsMobile = document.querySelectorAll(".edit-button-mobile")
console.log("ye le", editButtons)
editButtons.forEach(button => {
    button.addEventListener('click', editPacakageFromCart);
});
// editButtonsMobile.forEach(button => {
//     button.addEventListener('click', editPacakageFromCart);
// });

function editPacakageFromCart(event) {
  console.log("event", event)
  var modalConfirm = document.getElementById("myModalConfirm");
  var body = document.getElementsByTagName("body")[0];
  var confirmButton = document.getElementById("confirm");
  modalConfirm.style.display = "block";
  body.style.overflow = "hidden";
  confirmButton.onclick = () => {
    document.getElementById("confirm-text").style.display = "none";
    document.getElementById("confirm-loader").style.display = "block";
    editProduct(event.target)
  }
}

function editProduct(trg){
  let packRemoveBtn = trg.closest(".edit")
    ? trg.closest(".edit")
    : trg.classList.contains("edit-button")
    ? trg
    : null;
    console.log("remove", packRemoveBtn)
    let childProducts = packRemoveBtn
      .closest(".cart__packproduct")
      .querySelectorAll(".child_prod");
    console.log("childProducts2", childProducts);
    console.log("childProducts3", childProducts[0].className.split(" ").at(-1));
    let redirectUrl = childProducts[0].className.split(" ").at(-1);
    let varIdsToRemove = [];
    if (childProducts.length) {
      childProducts.forEach(function (prod) {
        let lineKey = prod.getAttribute("data-linekey");
        if (lineKey) {
          varIdsToRemove.push(lineKey);
        }
      });
    }
    console.log("ids:", varIdsToRemove)
    if (varIdsToRemove.length && !document.querySelector(".removingProducts")) {
      document.body.classList.add("removingProducts");
      removePackProductsFromCart(varIdsToRemove, redirectUrl);
    }
}